<template>
  <textarea
    :rows="rows"
    class="form_style"
    :class="{ input_error: error }"
    :placeholder="placeholder"
    v-model="model"
    :disabled="disabled"
  />
  <span v-if="error" class="input_error_txt">{{ errorText }}</span>
</template>

<script setup lang="ts">
const model = defineModel<string>({ required: true, default: "" });

defineProps({
  placeholder: {
    type: String,
    default: "", // placeholder 값
  },
  error: Boolean, // 에러 여부
  errorText: {
    type: String,
    default: "", // 에러 메시지
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  rows: {
    type: Number,
    default: 4, // 기본적으로 4행
  },
});
</script>
